import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed, onBeforeMount, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { CmsPage } from '@/modules/cms_page/CmsPage';
import PageLayout from '@/core/components/PageLayout.vue';
import { getValueInUserLanguage } from '@/core/languageContent';


export default /*@__PURE__*/_defineComponent({
  __name: 'CmsPageView',
  setup(__props) {

const store = useStore<AppStore>();
const route = useRoute();
const cmsPage = ref<CmsPage | null>(null);
const pageTitle = computed(() => {
	if (!cmsPage.value) {
		return '';
	}

	return getValueInUserLanguage(cmsPage.value.content, 'headline');
});

const load = async () => {
	await store.dispatch('loadCmsPages');

	const pageId = parseInt(route.params.id as string, 10);
	cmsPage.value = store.getters.cmsPages.find((p: CmsPage) => p.id === pageId);
};

watch(route, load);
onBeforeMount(load);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageLayout, { "page-title": pageTitle.value }, {
    default: _withCtx(() => [
      (cmsPage.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "panel",
            innerHTML: _unref(getValueInUserLanguage)(cmsPage.value.content, 'text')
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})